import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import SubscribePage from '../pages/SubscribePage';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import SelectCaptainAndViceCaptain from '../pages/SelectCaptainAndViceCaptain';
import LiveMatches from '../pages/LiveMatches';
import MatchDetails from '../pages/MatchDetails';
import FantasyGame from '../pages/FantasyGame';
import CreateFantasyTeam from '../pages/CreateFantasyTeam';
import MyMatches from '../pages/MyMatches';
import CreatePrediction from '../pages/CreatePrediction';
import PredictionGame from '../pages/PredictionGame';
import Leaderboard from '../pages/Leaderboard';
import Profile from '../pages/Profile';
import Auth from '../component/Auth';
import EditProfile from '../pages/EditProfile';
import ErrorBoundary from '../pages/ErrorBoundary';
import SubscriptionPage2 from '../pages/NewPages/SubscriptionPage2';
import LoginPage2 from '../pages/NewPages/LoginPage2';
import HomePage2 from '../pages/NewPages/HomePage2';
import CreateFantasyTeam2 from '../pages/NewPages/CreateFantasyTeam2';
import SelectCaptainAndViceCaptain2 from '../pages/NewPages/SelectCaptainAndViceCaptain2';
import FantasyGame2 from '../pages/NewPages/FantasyGame2';
import LiveMatches2 from '../pages/NewPages/LiveMatches2';
import MatchDetails2 from '../pages/NewPages/MatchDetails2';
import MyMatches2 from '../pages/NewPages/MyMatches2';
import CreatePrediction2 from '../pages/NewPages/CreatePrediction2';
import PredictionGame2 from '../pages/NewPages/PredictionGame2';
import Leaderboard2 from '../pages/NewPages/Leaderboard2';
import ProfilePage2 from '../pages/NewPages/ProfilePage2';
import EditProfilePage2 from '../pages/NewPages/EditProfilePage2';
import LanguagePage2 from '../pages/NewPages/LanguagePage2';
import OtpPage2 from '../pages/NewPages/OtpPage2';
import ConfirmationPage2 from '../pages/NewPages/ConfirmationPage2';
import LowBalancePage2 from '../pages/NewPages/LowBalancePage2';
import Auth2 from '../component/NewComponents/Auth2';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            // element: <SubscribePage />,
            element: <SubscriptionPage2 />,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/otp",
            element:<OtpPage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path:"/confirmation",
            element:<ConfirmationPage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path:"/low-balance",
            element:<LowBalancePage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path: "/login",
            element: <LoginPage2 />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/home",
            element:
                <Auth2>
                    <HomePage2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/create-fantasy-team",
            element:
                <Auth2>
                    <CreateFantasyTeam2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/select-captains",
            element:
                <Auth2>
                    <SelectCaptainAndViceCaptain2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        // 1). showing user rank is left, 2). showing how the player has got the point is left , 3). match commentry is left...
        {
            path: "/fantasy-game",
            element:
                <Auth2>
                    <FantasyGame2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/live",
            element:
                <Auth2>
                    <LiveMatches2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/match-details",
            element:
                <Auth2>
                    <MatchDetails2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/my-matches",
            element:
                <Auth2>
                    <MyMatches2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/create-prediction",
            element:
                <Auth2>
                    <CreatePrediction2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        // 1). showing user rank is left, 2). showing how the player has got the point is left , 3). match commentry is left...
        {
            path: "/prediction-game",
            element:
                <Auth2>
                    <PredictionGame2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/leaderboard",
            element:
                <Auth2>
                    <Leaderboard2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/profile",
            element:
                <Auth2>
                    <ProfilePage2 />
                </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/languages",
            element:<Auth2>
                <LanguagePage2 />
            </Auth2>
        },
        {
            path: "/edit-profile",
            element: <Auth2>
                <EditProfilePage2 />
            </Auth2>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "*",
            element: <Navigate to="/" />
        }

    ]);
    return (
        <RouterProvider router={router} />
    )
}

export default Routing